import SupplierAccountsApi from '../../apis/SupplierAccounts';
import AccountsApi from '../../apis/Accounts';


export default{
    namespaced: true,
    state: {
        debts: [],
        debt: null,
        response_payment: null,
        accounts: [],
        paginated:{}
    },
    mutations: {
        set_debts (state, data) {
            state.debts = data;
        },
        set_debt (state, data) {
            state.debt = data;
        },
        set_response_payment (state, data) {
            state.response_payment = data;
        },
        set_accounts (state, data) {
            state.accounts = data;
        },
        set_paginated (state, data) {
            state.paginated =  data
        }
    },
    actions: {
        selectDebt({commit}, data) {
            commit('set_debt', data);
        },
        async getDebts({commit, dispatch}, filters) {
            return await SupplierAccountsApi.get_allPaginated(filters)
                .then( response => {
                    commit('set_paginated', {
                        ...response.data
                    })
                    commit('set_debts', response.data.data)
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al listar cuentas por pagar, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async storeAmortize({commit, dispatch}, payment) {
            commit('set_response_payment', null);
            return await SupplierAccountsApi.amortize(payment)
                .then( response => {
                    commit('set_response_payment', response.data);
                    dispatch('notifications/store_notification', {
                        type: 'success',
                        message: 'El pago se realizó de forma correcta.'
                    }, {root: true});
                    dispatch('getDebts');
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al registrar pago, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async getAccounts({commit, dispatch}) {
            return await AccountsApi.get_all_card_transfer()
                .then( response => {
                    
                    commit('set_accounts', JSON.parse(JSON.stringify(response.data)));
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al listar cuentas por pagar, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
    }
}